export enum Environment {
    Development, 
    Staging,
    Production
}